import Breadcrumb from "@/components/base/Breadcrumb";
import ContactForm from "@/pages/contact/components/ContactForm";
import useSeo from "@/hooks/useSeo";

const CONTACT_INFO = [
  { icon: "ri-mail-line", label: "邮箱", value: "contact@shinoda-you.com" },
  { icon: "ri-weibo-fill", label: "微博", value: "@筱田优影视品牌" },
  { icon: "ri-wechat-fill", label: "微信公众号", value: "筱田优影视" },
  { icon: "ri-map-pin-line", label: "内容中心", value: "上海市徐汇区光影创意园" },
];

const SOCIALS = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-youtube-fill", label: "视频号" },
  { icon: "ri-instagram-line", label: "Instagram" },
];

export default function Contact() {
  useSeo({
    title: "联系我们 - 影迷留言与商务合作 | 筱田优官网",
    description:
      "欢迎通过邮箱或在线反馈与我们联系，无论是影迷建议还是商务合作，我们都期待听到你的声音。",
    keywords: "联系筱田优,影迷留言,商务合作,联系方式",
  });

  return (
    <div className="w-full pt-20 md:pt-24">
      <div className="bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-8 md:py-12">
          <Breadcrumb items={[{ label: "联系我们" }]} />
          <h1 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mt-4">联系我们</h1>
          <p className="text-sm md:text-lg text-foreground-600 mt-4 max-w-2xl leading-relaxed">
            无论是影迷的留言建议，还是媒体的采访与商务合作，我们都期待与你的交流。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
        <div className="lg:col-span-2">
          <ContactForm />
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-lg bg-background-50 border border-background-200 p-6">
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-5">联系信息</h3>
            <div className="flex flex-col gap-5">
              {CONTACT_INFO.map((item) => (
                <div key={item.label} className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-lg`} />
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">{item.label}</p>
                    <p className="text-sm font-medium text-foreground-900 mt-0.5">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 pt-6 border-t border-background-200">
              <p className="text-xs text-foreground-400 mb-3">关注我们</p>
              <div className="flex items-center gap-3">
                {SOCIALS.map((s) => (
                  <a
                    key={s.label}
                    href="#"
                    title={s.label}
                    aria-label={s.label}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    <i className={`${s.icon} text-lg`} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-accent-100 p-6">
            <h3 className="font-heading text-base font-bold text-accent-900 mb-2 flex items-center gap-2">
              <i className="ri-lightbulb-line" />
              温馨提示
            </h3>
            <p className="text-sm text-accent-900/80 leading-relaxed">
              本站为演示站点，提交的留言仅用于展示提交流程，我们会尽快回复每一份真诚的来信。
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
}